import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import copy from 'copy-to-clipboard';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../components/DataNotFound';
import LoadingAnimation from '../../../components/LoadingAnimation';
import { reactURL } from '../../../components/helper/axiosHelper';
//import useCopyToClipboard from '../../../hooks/useCopyToClipboard/useCopyToClipboard';

const ServiceTable = ({ pageSize, columns, value, isLoad, datanotfound, next }) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const { t } = useTranslation();

  const copyLink = async (e, item) => {
    e.preventDefault();
    try {
      if (
        item?.projectLink === undefined ||
        item?.projectLink === null ||
        item?.projectLink === '' ||
        item?.projectID === undefined ||
        item?.projectID === null ||
        item?.projectID === 0
      ) {
        toast.warning(`${t('Failed to copy refferal link data not found')}`);
      } else {
        const gwaReferralLink = `${reactURL}/PaymentProcess/${item?.projectID}/${item?.projectLink}/${5}/${item?.projectTypeIdInt}`;
        copy(gwaReferralLink);
        toast.success(`${t('Link copy Successfully')}`);
      }
    } catch (error) {
      console.error('Error fetching record:', error);
    }
  };

  return (
    <>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        {isLoad ? (
          <LoadingAnimation />
        ) : (
          value?.length > 0 && (
            <Table className="text-sm  tableData text-left rtl:text-right text-gray-500">
              <Table.Header className="text-sm  bg-customgreen uppercase">
                <Table.Row>
                  {columns.map((column, index) => (
                    <Table.Cell key={index} scope="col" className="px-6 py-3 text-white  tracking-wider">
                      {t(`${column}`)}
                    </Table.Cell>
                  ))}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {value?.map((item, index) => {
                  const sno = (next - 1) * pageSize + index + 1;

                  return (
                    <Table.Row key={index} className={`border-b   ${index % 2 === 0 ? '' : ''}`}>
                      <Table.Cell className="px-6 py-4 whitespace-nowrap">{sno}</Table.Cell>
                      <Table.Cell className="px-2 md:px-6 py-4 whitespace-nowrap ">
                        {isActive
                          ? item?.projectNameAR
                          : item?.projectNameEn !== ''
                            ? item?.projectNameEn
                            : item?.projectNameAR}
                      </Table.Cell>
                      <Table.Cell className="px-6 py-4 whitespace-nowrap  ">{item?.date}</Table.Cell>
                      <Table.Cell className="px-6 py-4 whitespace-nowrap  ">{item?.timeNow}</Table.Cell>
                      <Table.Cell className="px-6 py-4 whitespace-nowrap ">
                        <button
                          className="text-customgreen hover:text-white border-2 border-customgreen hover:bg-hovergreen  focus:outline-none focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 text-center"
                          onClick={(e) => copyLink(e, item)}
                        >
                          <LinkOutlinedIcon />
                          {t('Copy Link')}
                        </button>
                      </Table.Cell>
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          )
        )}
        {datanotfound && <DataNotFound />}
      </div>
    </>
  );
};

export default ServiceTable;
